<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  import Modal from './Modal.svelte'
  import { getApiUrl } from './util'

  export let data

  let awaitingRefresh = false
  function onDataChange(d) { awaitingRefresh = false }
  $: { onDataChange(data) }

  // Variables related to the information request modal

  let inforeqModal

  let inforeqtext
  let inforeqstatus

  const inforeqstatuses = [
    { val: 'active', lbl: 'Active' },
    { val: 'inactive', lbl: 'Inactive' }
  ]

  // End of modal variables

  function getFormApiUrl(oppath) {
    const apipath = `forms/${data.formid}/${oppath}`
    return getApiUrl(apipath)
  }

  function dispatchStaleDataEvent() {
    awaitingRefresh = true
    dispatch('staleformdata')
  }


  // Duplicated in FieldValueActions
  async function fetchWrapper(url, options) {
    options['cache'] = 'no-store'
    let res
    try {
      res = await fetchWithSession(url, options)
      if (!res.ok) {
        console.log(res)
        res?.text().then(t => console.log(t))
        alert('ERROR: API call status ' + res.status)
      }
    } catch(err) {
      console.log(err)
      alert('ERROR attempting API call.  See console log.')
    }
    return res
  }


  async function setActivation(active=true) {
    awaitingRefresh = true
    const method = active ? 'PUT' : 'DELETE'
    try {
      const apiurl = getFormApiUrl('inforeqactivation')
      await fetchWrapper(apiurl, { method })
    } finally {
      dispatchStaleDataEvent()
    }
  }

  async function deactivateInfoReq() {
    setActivation(false)
  }

  async function activateInfoReq() {
    setActivation(true)
  }

  function showInfoRequestModal() {
    inforeqtext = data.inforeqtext
    inforeqstatus = data.inforeqstatus || 'active'
    inforeqModal.show()
  }

  async function executeInfoReqModalAction() {
    const bodydata = { inforeqtext, inforeqstatus }
    const apiurl = getFormApiUrl('inforeq')
    const method = 'PUT'
    const res = await fetchWrapper(apiurl,
      { method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodydata)
      })
    if (res?.ok) {
      dispatchStaleDataEvent()
      inforeqModal.hide()
    }
  }

</script>


<fieldset class=actionbuttons disabled={awaitingRefresh}>
  <legend>Form-level actions</legend>
  <button on:click={activateInfoReq}
          class:show={data.inforeqstatus==='inactive'}
    >Activate information request</button>
  <button on:click={deactivateInfoReq}
          class:show={data.inforeqstatus==='active'}
    >Deactivate information request</button>
  <button on:click={showInfoRequestModal}
          class:show={!data.forminforequestid}
    >Create information request</button>
  <button on:click={showInfoRequestModal}
          class:show={!!data.forminforequestid}
    >Edit information request</button>
</fieldset>

<div class=inforeqmodalcontainer>
<Modal bind:this={inforeqModal}>
  <div class=modalcontent>
    <label class=inforeqtext>
      Text of information request...
      <textarea class=inforeqtext
                rows=10
                cols=60
                autocomplete=off
                bind:value={inforeqtext}></textarea>
    </label>
    <fieldset class=inforeqstatus>
      Information request status:
      {#each inforeqstatuses as status}
        <label>
          <input type=radio bind:group={inforeqstatus} value={status.val}>
          {status.lbl}
        </label>
      {/each}
    </fieldset>
    <div class=inforeqbuttons>
      <button on:click={inforeqModal.hide}>Cancel</button>
      <button on:click={executeInfoReqModalAction}>Save</button>
    </div>
  </div>
</Modal>
</div>

<style>
  .actionbuttons {
    margin-top: 1em;
    display: inline-block;
  }
  .actionbuttons button {
    display: none;
  }
  .actionbuttons button.show {
    display: initial;
  }
  .modalcontent {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  label.inforeqtext {
    display: block;
  }
  textarea.inforeqtext {
    resize: none;
    width: 100%;
    flex-grow: 1;
    margin-bottom: 1em;
    border: 2px solid lightgray;
  }
  fieldset.inforeqstatus {
    margin: 0 0 1em 0;
    padding: 0;
    border: none;
  }
  .inforeqstatus label {
    padding-left: 1em;
  }
  .inforeqmodalcontainer :global(span.close) {
    display: none;
  }
</style>
